import {
  FETCH_FILTROS,
  GET_FILTROS,
  LIMPIAR_FILTROS,
  LIMPIAR_FILTROS_TEXTO,
  REMOVE_FILTRO,
  UPDATE_FILTROS,
} from '../actions/types.js'

const initialState = {
  filtros: { filtros: [], isLoading: false },
  filtros_claves_estadisticas: {
    filtros_claves_estadisticas: [],
    isLoading: false,
  },
  filtros_aplicados: [],
  filtros_texto_aplicados: [],
  isLoading: false,
  ignorar_filtro_url: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FILTROS:
      return {
        ...state,
        filtros: { filtros: [], isLoading: true },
        filtros_claves_estadisticas: {
          filtros_claves_estadisticas: [],
          isLoading: true,
        },
      }
    case GET_FILTROS:
      let filtros = {
        filtros: action.payload['filtros'],
        isLoading: false,
      }

      let filtros_claves = {
        filtros_claves_estadisticas: action.payload['filtros_claves'],
        isLoading: false,
      }
      return {
        ...state,
        filtros: filtros,
        filtros_claves_estadisticas: filtros_claves,
      }
    case LIMPIAR_FILTROS:
      return {
        ...state,
        isLoading: false,
        filtros_aplicados: [],
        familia_seleccionada: '',
        ignorar_filtro_url: true,
      }
    case LIMPIAR_FILTROS_TEXTO:
      return {
        ...state,
        isLoading: false,
        filtros_texto_aplicados: [],
      }
    case UPDATE_FILTROS:
      if (action.payload.tipo === 'search') {
        return {
          ...state,
          isLoading: false,
          filtros_texto_aplicados: [...state.filtros_texto_aplicados, action.payload],
        }
      } else {
        return {
          ...state,
          isLoading: false,
          filtros_aplicados: [...state.filtros_aplicados, action.payload],
        }
      }
    case REMOVE_FILTRO:
      let isSearch = action.payload.tipo === 'search'
      let targetArray = isSearch ? state.filtros_texto_aplicados : state.filtros_aplicados

      let findPos = elem => {
        if (isSearch) {
          return String(elem.nombre) === String(action.payload.nombre) && elem.tipo === 'search'
        }
        return String(elem.estadistico) === String(action.payload.estadistico) &&
          String(elem.familia) === String(action.payload.familia)
      }

      let aux = targetArray.slice()
      let pos = aux.findIndex(findPos)
      pos !== -1
        && aux.splice(pos, 1)

      return {
        ...state,
        isLoading: false,
        ...(isSearch
          ? { filtros_texto_aplicados: aux }
          : {
            filtros_aplicados: aux,
            familia_seleccionada: '',
          }),
      }
    default:
      return state
  }
}
